import React from 'react';

const CheckIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
    >
        <circle
            cx="19"
            cy="19"
            r="17.0667"
            fill="white"
            stroke="white"
            stroke-width="2.13333"
        />
        <path
            d="M19.001 5.66406C26.3647 5.66406 32.3348 11.6334 32.335 18.9971L32.3301 19.3418C32.1474 26.5464 26.2496 32.3311 19.001 32.3311L18.6572 32.3262C11.4525 32.1437 5.66797 26.2458 5.66797 18.9971C5.66814 11.6335 11.6374 5.66424 19.001 5.66406ZM19.001 7.33105C12.5579 7.33123 7.33514 12.554 7.33496 18.9971C7.33496 25.4403 12.5578 30.6639 19.001 30.6641C25.4443 30.6641 30.668 25.4404 30.668 18.9971C30.6678 12.5539 25.4442 7.33105 19.001 7.33105ZM24.3125 14.2324C24.6228 13.9223 25.1243 13.9223 25.4346 14.2324C25.7449 14.5427 25.7448 15.0441 25.4346 15.3545L17.0156 23.7744C16.7054 24.0847 16.2039 24.0844 15.8936 23.7744L12.5664 20.4482C12.2562 20.138 12.2564 19.6366 12.5664 19.3262C12.8768 19.0158 13.3781 19.0158 13.6885 19.3262L16.4502 22.0869L24.3125 14.2324Z"
            fill="url(#paint0_linear_10489_23142)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_10489_23142"
                x1="32.335"
                y1="18.9976"
                x2="6.29599"
                y2="14.9537"
                gradientUnits="userSpaceOnUse"
            >
                <stop
                    offset="0.0288398"
                    stopColor="var(--gradient-primary-1)"
                />
                <stop offset="1" stopColor="var(--gradient-primary-2)" />
            </linearGradient>
        </defs>
    </svg>
);

export default CheckIcon;
